/**
 * @generated SignedSource<<285a7d2547dc727f1b96a41b0ab3ca18>>
 * @relayHash 28febb2c31285c1e690c5c06c7b9b605
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b646221c7c35d7c849f518c9b5c45fba866e6a9d292b0226e3f7f776dc677fa2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PendingJourneysPageQuery } from './PendingJourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<PendingJourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b646221c7c35d7c849f518c9b5c45fba866e6a9d292b0226e3f7f776dc677fa2",
    "metadata": {},
    "name": "PendingJourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
